export default __webpack_public_path__ + "static/media/img_employee_tip11.f1c15cd3.png";